
function pageHeader() {
 
  var directive = {
    template: require('./flexi.pageHeader.html'),
    controller: PageHeaderController,
    controllerAs: 'pageHeaderController',
    bindToController: true
  };

  function PageHeaderController($scope, coreService) {
	var vm = this;
	vm.baseUri = "https://flexipurchase.com";
    var model = coreService.getIdentityModel();
	if (model && model.custom)
	{ 
	vm.baseUri = model.custom.api_base;		
	}  
  }
  return directive;
};
export default pageHeader;


// WEBPACK FOOTER //
// ./src/login/header/flexi.pageHeader.js